document.addEventListener("DOMContentLoaded", function () {

    document.querySelectorAll(".word-count-field textarea, .word-count-field input").forEach(function (input) {

        // Ensure we don't duplicate counters if script runs multiple times
        if (input.parentNode.querySelector(".word-count-indicator")) return;

        // Calculate max words based on max characters (assuming 6 characters per word)
        let maxChars = parseInt(input.getAttribute("maxlength")) || 0;
        let maxWords = maxChars > 0 ? Math.floor(maxChars / 6) : "∞";

        // Create the word count display
        let counter = document.createElement("div");
        counter.className = "word-count-indicator";
        counter.style.marginTop = "5px";
        counter.style.fontSize = "11px";
        counter.style.color = "#666";
		counter.style.opacity = "0.25"; // Initially hidden

        input.parentNode.appendChild(counter); // Insert below input/textarea

		function updateWordCount() {
            let words = input.value.trim().split(/\s+/).filter(word => word.length > 0).length; // Count words
            if (words === 0) {
                counter.style.opacity = "0.25"; // Hide counter if no words
            } else {
                counter.style.opacity = "1"; // Show counter when words are present
            }
			let wordText = words === 1 ? "word" : "words"; // Singular/plural
            counter.innerText = `${words} ${wordText}`;
        }

        input.addEventListener("input", updateWordCount);
        updateWordCount(); // Initialize on page load
    });
});

